import { globalT } from '@/main.js'
import { useAppStore } from '@/stores/AppStore'

export function useRedirectToError(router) {
  if (!router) {
    throw new Error('Router is not defined')
  }

  const appStore = useAppStore()
  const translationPath = 'composables.useRedirectToError'

  // Default state
  const state = {
    icon: 'circle-xmark',
    title: globalT(`${translationPath}.title`),
    message: globalT(`${translationPath}.message`),
    status: 404,
  }

  const api = {
    setIcon(icon) {
      state.icon = icon
      return api
    },
    setTitle(title) {
      state.title = title
      return api
    },
    setMessage(message) {
      state.message = message
      return api
    },
    setStatus(status) {
      state.status = status
      return api
    },
    async redirect() {
      appStore.$patch({
        errorIcon: state.icon,
        errorTitle: state.title,
        errorMessage: state.message,
        errorCode: state.status,
      })

      await router.push({ name: 'error' })
    },
  }

  return api
}
